import { apiSlice } from './apiSlice';

export interface UsersResponse {
  totalBlocked: number | null;
  totalActive: number;
  count: number;
  data: {
    id: string;
    firstname: string | null;
    lastname: string | null;
    fullName: string;
    username: string;
    email: string;
    dialCode: string | null;
    mobile: string | null;
    profileImage: string | null;
    isVerified: boolean;
    city: string;
    state: string;
    country: string;
    status: string;
    userType: string;
    userLoginType: string;
    createdAt: string;
    updatedAt: string;
    parentId: string | null;
    meta: {
      id: string;
      ascendant: string | null;
      dateOfBirth: string;
      gender: string | null;
      googleId: string | null;
      latitude: number;
      longitude: number;
      moonSign: string | null;
      placeOfBirth: string;
      timeOfBirth: string;
      sunSign: string | null;
      timezone: number;
      userId: string;
      zodiacSign: string | null;
    };
  }[];
}

export const usersApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    users: builder.query<
      UsersResponse,
      {
        reportType?: string;
        userLoginType?: string;
        take: number;
        skip: number;
      }
    >({
      query: ({ reportType, userLoginType, take, skip }) => {
        const queryParams = new URLSearchParams();

        queryParams.append('take', String(take));
        queryParams.append('skip', String(skip));

        if (reportType === 'analytics') {
          queryParams.append('status', 'Active');
        }

        if (reportType === 'user') {
          queryParams.append('status', 'Blocked');
        }

        if (userLoginType && userLoginType !== 'all') {
          queryParams.append('userLoginType', userLoginType);
        }

        return `/users?${queryParams.toString()}`;
      },
    }),
  }),
});

export const { useUsersQuery } = usersApi;
